import { render, staticRenderFns } from "./ModalDetails.vue?vue&type=template&id=4a0a0135&"
import script from "./ModalDetails.vue?vue&type=script&lang=js&"
export * from "./ModalDetails.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetails.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports